module.exports = __webpack_public_path__ + "static/media/ic_select.d506bbae.svg";